import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';

class SelestSubject{

    GetStudentRegistrationCourses(StudentID, FacultyID  , SpecializationID, LevelID, CourseCode = 'p', CourseName = 'p', RoleViewID=3 ){
        return axios.get(API_URL + `StudentRegistration/StudentRegistrationCourses?StudentID=${StudentID}&FacultyID=${FacultyID}&SpecializationID=${SpecializationID}&LevelID=${LevelID}&CourseCode=${CourseCode}&CourseName=${CourseName}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }

    // GET /api/StudentRegistration/GetAllCourseSections
    GetAllCourseSections(CourseId, StudentId , EnrollmentStudentId ){
        return axios.get(API_URL + `StudentRegistration/GetAllCourseSections?CourseId=${CourseId}&StudentId=${StudentId}&EnrollmentStudentId=${EnrollmentStudentId}`,
        { headers: authHeader() } )        
    }


    AddToCart(StudentID, CourseID , Sections, RoleViewID ){
        return axios.post(API_URL + `StudentRegistration/AddToCart?StudentID=${StudentID}&CourseID=${CourseID}&RoleViewID=${RoleViewID}`,
        Sections,{ headers: {
            'Content-Type': 'application/json',
          }, } )        
    }

    // GET /api/StudentRegistration/GetCartItems
    GetCartItems(StudentID, RoleViewID ){
        return axios.get(API_URL + `StudentRegistration/GetCartItems?StudentID=${StudentID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }

    StudentCartItems(StudentID, RoleViewID ){
        return axios.get(API_URL + `StudentRegistration/StudentCartItems?StudentID=${StudentID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }


    GetFacultyLevels(FacultyID){
        return axios.get(API_URL + `StudentRegistration/GetFacultyLevels?FacultyID=${FacultyID}`,{
    
        },
        { headers: authHeader() } )
      }

      GetFacultySpecializations(FacultyID){
        return axios.get(API_URL + `StudentRegistration/GetFacultySpecializations?FacultyID=${FacultyID}`,{
    
        },
        { headers: authHeader() } )
      }

      // POST /api/StudentRegistration/RemoveCartItem
      RemoveCartItem(StudentID, courseID, RoleViewID ){
        return axios.post(API_URL + `StudentRegistration/RemoveCartItem?StudentID=${StudentID}&courseID=${courseID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }

    // POST /api/StudentRegistration/RegisterOneCourse
    RegisterOneCourse(StudentID, CourseID, RoleViewID ){
        return axios.post(API_URL + `StudentRegistration/RegisterOneCourse?StudentID=${StudentID}&CourseID=${CourseID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }

    // POST /api/StudentRegistration/RegisterAll
    RegisterAll(StudentID, RoleViewID ){
        return axios.post(API_URL + `StudentRegistration/RegisterAll?StudentID=${StudentID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }
    DropRegesterdCourse(StudentID, CourseID, RoleViewID ){
        return axios.get(API_URL + `StudentRegistration/DropStudentRegisteredCourse?StudentID=${StudentID}&CourseID=${CourseID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }
    UpdateRegesterdCourse(StudentID, CourseID, RoleViewID ){
        return axios.get(API_URL + `StudentRegistration/ReturnRegisteredCourseToCartForUpdate?StudentID=${StudentID}&CourseID=${CourseID}&RoleViewID=${RoleViewID}`,
        { headers: authHeader() } )        
    }
    SelectBasicCourses(StudentId){
        return axios.get(API_URL + `StudentSchedule/StudentBasicCourses?StudentId=${StudentId}`)
    }
    GetRegistrationPeriodSelect(){
        return axios.get(API_URL + `StudentRegistration/GetRegistrationPeriodSelect`)
    }
    CheckRegisteredCoRequisite(StudentId,CourseId){
        return axios.get(API_URL + `StudentRegistration/Check_Registered_CoRequisite?StudentID=${StudentId}&Courseid=${CourseId}`)
    }
    StudentCustomRegistrationCourses(StudentId,RoleViewId){
        return axios.get(API_URL + `StudentRegistration/StudentCustomRegistrationCourses?StudentID=${StudentId}&RoleViewID=${RoleViewId}`)
    }


}

export default new SelestSubject();